module.exports = __webpack_public_path__ + "media/images/pages/ic-filter-even-3b96d930bc717294175b797ee647a136.png";